export const fetchRisks = (filter) => ({
    method: 'GET',
    url: `/risks?filter=${filter}`
});